import { pluralsightCertificates } from "./certificatesData";

export const siteUrl = "https://www.robertdoe.com";
export const siteName = "Robert Doe";
export const defaultOgImage = `${siteUrl}/og-image.jpg`;

export const navLinks = [
  { label: "Research", href: "/research" },
  { label: "Projects", href: "/projects" },
  { label: "Writing", href: "/books" },
  { label: "About", href: "/about" },
  { label: "CV", href: "/resume" },
  { label: "Contact", href: "/contact" },
];

export const resumeUrl = "/Robert-Doe-CV.pdf";

export const books = [
  {
    id: "xss-engineering",
    title: "XSS Engineering",
    status: "Completed · Pending review",
    coverStatus: "Pending review",
    description:
      "We have completed the manuscript for XSS Engineering, a book exploring cross-site scripting and web security through an engineering lens.",
    note: "The manuscript is complete and pending review.",
    tags: [],
  },
  {
    id: "why-my-browser-has-mood-swings",
    title: "Why My Browser has mood swings",
    status: "Currently writing",
    description:
      "We are currently writing Why My Browser has mood swings, a playful look at browsers, their quirks, and the engineering behind them.",
    note: "The book is a work in progress. More details will be shared as the writing develops.",
    tags: [],
  },
  {
    id: "the-human-attack-surface",
    title: "The Human Attack Surface: A Multidisciplinary History of Social Engineering",
    coverTitle: "The Human Attack Surface",
    subtitle: "A Multidisciplinary History of Social Engineering",
    status: "Currently writing",
    description:
      "We are currently writing The Human Attack Surface: A Multidisciplinary History of Social Engineering, exploring the history of social engineering across disciplines.",
    note: "The book is a work in progress. More details will be shared as the writing develops.",
    tags: [],
  },
];

export const aboutAwards = [
  {
    icon: "*",
    title: "MasterCard Foundation Scholar",
    description:
      "Awarded for academic excellence and social impact leadership across Africa.",
  },
  {
    icon: "*",
    title: "Google Africa Developer Scholar",
    description:
      "Recognized as a top developer talent across the African continent.",
  },
];

export const aboutStats = [
  { value: "1000+", label: "Youth Trained to Code" },
  { value: "25+", label : "Projects Shipped" },
];

export const skillCategories = [
  {
    icon: "{ }",
    name: "Languages & Runtimes",
    tags: [
      "Python",
      "TypeScript",
      "JavaScript ES6+",
      "Java",
      "PHP",
      "Dart",
      "C / C++",
    ],
  },
  {
    icon: "</>",
    name: "Frontend & Mobile",
    tags: [
      "React",
      "Next.js",
      "Redux",
      "Flutter",
      "HTML5 / CSS3",
      "jQuery",
      "Figma",
      "Adobe XD",
    ],
  },
  {
    icon: "API",
    name: "Backend & APIs",
    tags: [
      "Node.js",
      "Express",
      "FastAPI",
      "Flask",
      "RESTful APIs",
      "GraphQL",
      "WebSockets",
    ],
  },
  {
    icon: "DB",
    name: "Databases & Storage",
    tags: ["PostgreSQL", "MySQL", "MongoDB", "Redis"],
  },
  {
    icon: "ML",
    name: "Data & Machine Learning",
    tags: [
      "TensorFlow",
      "scikit-learn",
      "XGBoost",
      "Hugging Face",
      "Pandas",
      "NumPy",
    ],
  },
  {
    icon: "SEC",
    name: "Security Research",
    tags: [
      "Web Vuln Analysis",
      "XSS / CSRF",
      "Memory Safety",
      "Blackbox Web Scanning",
      "OWASP",
    ],
  },
];

export const experienceItems = [
  {
    role: "Research Assistant - Web & Browser Security",
    date: "Aug 2024 - Present",
    org: "Arizona State University",
    bullets: [
      "Dissertation research on detecting and preventing DOM-based XSS in the browser, combining static and runtime signals.",
      "Built browser instrumentation to measure how client-side code manipulates the DOM and where a lightweight runtime defense can act with minimal overhead.",
      "Developed hybrid labeling strategies (automated heuristics plus human review) to cut false positives in web-vulnerability classification, using Trusted Types and the Sanitizer API.",
    ],
  },
  {
    role: "Grader - Computing Ethics & HCI",
    date: "2024 - 2026",
    org: "Arizona State University",
    bullets: [
      "Graded CSE 301 Computing Ethics across five terms (2024-2026).",
      "Graded CSE 463 Introduction to Human-Computer Interaction (2024-2025).",
    ],
  },
  {
    role: "Research Assistant / Teaching Assistant - Memory Safety & Capability Architectures",
    date: "Aug 2023 - May 2024",
    org: "Arizona State University, Tempe",
    bullets: [
      "Built IR-level LLVM passes (FunctionPass, ModulePass) and contributed backend MachineFunctionPass work to emit instrumented RISC-V assembly for a research capability architecture, tagging pointers and memory regions with hardware capabilities to stop buffer overflow, use-after-free, double-free, and ROP in unmodified C/C++ programs.",
      "Added an ISA-level instrumentation path that records which instructions execute and their latency, used to quantify the runtime overhead of capability enforcement before code generation.",
      "Co-authored the STAM Center memory-safety benchmark suite used to validate the compiler; compiler and benchmarks released open source.",
    ],
  },
  {
    role: "Teaching Assistant - C++ & Informatics",
    date: "Fall 2023 - 2024",
    org: "Arizona State University",
    bullets: [
      "Taught CSE 100 (Principles of Programming with C++), Fall 2023.",
      "Taught CPI 101 (Introduction to Informatics) across two terms, 2023-2024.",
    ],
  },
  {
    role: "Full Stack Developer",
    date: "Oct 2022 - 2023",
    org: "McGill University (MCF Transitions), MasterCard Foundation - Canada",
    bullets: [
      "Built a cross-institutional research and internship platform connecting three Ghanaian universities (KNUST, UESD, KTU) with a React front end, Node.js back end, and Figma-designed UI.",
      "Shipped cross-institution internship applications, supervisor monitoring and grading tools, and co-authored research-project management, with responsive cross-browser support for users in Ghana and Canada.",
      "System design reviewed by program stakeholders.",
    ],
  },
  {
    role: "Instructor & Teaching Assistant",
    date: "Oct 2021 - Oct 2022",
    org: "KNUST, Ghana",
    bullets: [
      "Taught Programming Fundamentals through the Institute of Distance Learning, 2022-2023.",
      "Taught C++ and Data Structures in the Regular Stream, 2021-2022.",
    ],
  },
  {
    role: "Full Stack Developer - CARISCA LMS",
    date: "Aug - Dec 2021",
    org: "KNUST, Ghana - USAID Funded, with ASU",
    bullets: [
      "Authored a software development document detailing architecture, workflows, and integration strategies to streamline collaboration.",
      "Built and rigorously tested RESTful APIs to facilitate interaction between Moodle and project subcomponents, ensuring reliable data flow across the platform.",
      "Integrated WhatsApp with the LMS for real-time updates, enhancing user engagement and platform communication.",
    ],
  },
];

export const projects = [
  {
    id: "EdTech - codeden.org",
    name: "Code Den",
    description:
      "EdTech platform training the youth of Africa to code. Dual-platform: a mobile app (Flutter) and web platform (React). Has taught 1000+ African youth digital literacy and technical skills for emerging job markets across the continent.",
    tags: ["React", "Flutter", "Node.js", "EdTech", "Africa"],
    links: [
      { label: "Live Site", href: "https://codeden.org" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/" },
    ],
  },
  {
    id: "Research Platform - Canada",
    name: "Nkabom Project",
    description:
      "Interactive web platform for research collaboration between lecturers and students across universities. Includes an internship application system and supervisor assessment tools for tracking student progress.",
    tags: ["React", "Node.js", "PostgreSQL", "HCI", "Research Collab"],
    links: [{ label: "GitHub", href: "https://github.com/Robert-Doe/" }],
  },
  {
    id: "Job Platform - Ghana",
    name: "theCut - RxHealth",
    description:
      "Job hub platform for barbers, makeup artists, and cosmetic shop owners in Ghana. Integrated PayStack for secure in-app payments, achieved 98% customer satisfaction rating, and delivered a 40% reduction in load times via caching optimizations and efficient database queries.",
    tags: ["React", "Node.js", "Flutter", "PayStack", "MongoDB"],
    links: [{ label: "GitHub", href: "https://github.com/Robert-Doe/" }],
  },
  {
    id: "Scheduling System - KNUST",
    name: "Helix Table Time",
    description:
      "Web-based class scheduling platform for KNUST's College of Science. Applied graph coloring principles for conflict-free timetable arrangement and a knapsack-inspired algorithm for efficient allocation of classrooms, labs, and resources across the college.",
    tags: ["React", "Graph Coloring", "Algorithms", "Scheduling", "Python"],
    links: [{ label: "GitHub", href: "https://github.com/Robert-Doe/" }],
  },
  {
    id: "Learning Management - KNUST & ASU",
    name: "CARISCA Academy LMS",
    description:
      "Learning Management System for supply chain education across Africa, partnered with Arizona State University and supported by USAID. Integrated WhatsApp messaging with Moodle via RESTful APIs for real-time student engagement and platform communication.",
    tags: ["Moodle", "RESTful API", "WhatsApp API", "PHP", "MySQL"],
    links: [
      {
        label: "Live Site",
        href: "https://www.cariscaacademy.org/about-us",
      },
    ],
  }
 /* {
    id: "Church Web Platform - Phoenix, AZ",
    name: "Phoenix Ghanaian SDA Church",
    description:
      "Full community website for the Phoenix Ghanaian Seventh-day Adventist congregation. Features sermon streaming, event management, online giving, member portal, and admin-controlled announcements - serving a Ghanaian diaspora faith community in Arizona.",
    tags: ["HTML / CSS", "JavaScript", "Community Platform", "Events", "Live Streaming"],
    links: [
      {
        label: "Live Site",
        href: "https://phoenixghanasda.netlify.app/",
      },
      { label: "GitHub", href: "https://github.com/Robert-Doe/" },
    ],
  }*//*,
  {
    id: "Digital Hymnal - Ghana SDA",
    name: "Ghana SDA Hymnal",
    description:
      "Interactive digital hymnal built for Ghana SDA congregations, enabling hymn search, display, and structured worship preparation. Designed as a practical tool for worship leaders and members to access the full hymnal digitally across devices.",
    tags: ["React", "JavaScript", "Worship Tech", "Ghana"],
    links: [
      {
        label: "Live Site",
        href: "https://ghanasdahymnal.netlify.app/",
      },
      { label: "GitHub", href: "https://github.com/Robert-Doe/" },
    ],
  }*/,
  {
    id: "Health & Wellness App - Web / PWA",
    name: "Luna - Cycle Tracker",
    description:
      "Progressive web app for menstrual cycle tracking with AI-powered health tips, daily logging, partner access via shared codes, and email reminders. Installable on mobile, works offline, and built with privacy-first design - no data leaves the app without user action.",
    tags: ["PWA", "Supabase", "AI Tips", "JavaScript", "Health Tech"],
    links: [
      { label: "Live Site", href: "https://ellenluna.netlify.app/" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/" },
    ],
  },
  {
    id: "Personal / Professional - Accra, Ghana",
    name: "mfantse.tech",
    description:
      "Personal web presence and professional platform. A clean, purposeful digital identity built to showcase work, facilitate connections, and represent a professional brand rooted in Ghanaian identity and technical craft.",
    tags: ["Web Design", "JavaScript", "Personal Brand", "Ghana"],
    links: [
      { label: "Live Site", href: "https://mfantse.tech/" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/" },
    ],
  },
];

export const systemsProjects = [
  {
    id: "Systems - Compiler",
    name: "A-finity",
    badge: "In Progress",
    description:
      "A hand-written C compiler taken from source bytes to a linkable x86-64 ELF object: lexer, symbol table, recursive-descent parser, semantic analysis, an IR, optimization passes, register allocation, and code generation, plus a parallel Java/JavaScript parsing-theory track. Built to reason about miscompilation and code-generation bugs the way a vulnerability researcher has to, not the way a compiler user does.",
    tags: ["Compilers", "Lexing & Parsing", "Code Generation", "x86-64 ELF", "AppSec Education"],
    links: [
      { label: "Live Demo", href: "https://a-finity.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/a-finity" },
    ],
  },
  {
    id: "Systems - Operating System",
    name: "theBud OS",
    badge: "In Progress",
    description:
      "An x86 operating system built by hand from the bootloader to a POSIX-flavored kernel, plus a toy multi-process browser built on top of it to study sandboxing, site isolation, and exploit mitigations at the OS layer that actually enforces them. Paired with A-finity as a two-part systems series - a practical on-ramp for reasoning about privilege escalation and memory-safety bugs in a machine assembled by hand rather than taken on faith.",
    tags: ["Operating Systems", "x86 Assembly", "Memory Management", "Privilege Rings", "AppSec Education"],
    links: [
      { label: "Live Demo", href: "https://thebud-os.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/thebud-os" },
    ],
  },
  {
    id: "Systems - Programming Languages",
    name: "Alonzo",
    badge: "In Progress",
    description:
      "Lambda calculus from scratch: a code-first course that builds a λ-engine module by module, each with a live Lab, a tutorial, and a decision record. Thirteen of its 34 engine modules are done so far: term ASTs, a lexer and parser, α-equivalence, capture-avoiding substitution, de Bruijn indices, reduction strategies, Church–Rosser, and Church encodings. Still ahead are abstract machines (Krivine, CEK), type systems through Hindley–Milner and System F, and an Alonzo-ML compiler to C and WebAssembly.",
    tags: ["Lambda Calculus", "Programming Languages", "Interpreters", "Type Theory"],
    links: [
      { label: "Live Demo", href: "https://lambda.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/alonzo" },
    ],
  },
  {
    id: "Systems - Browser Engine",
    name: "Rendercore",
    badge: "Complete",
    description:
      "A browser rendering engine built from raw sockets to painted pixels in pure Python: hand-rolled HTTP/TLS, an HTML tokenizer and tree builder, a CSS cascade and layout engine, and a toy JS interpreter, with same-origin enforcement and sandboxing layered on top. Grounds a claim like \"the same-origin policy prevents X\" in something implemented and broken by hand, not read from documentation.",
    tags: ["Python", "Browser Engine", "HTML/CSS Parsing", "Same-Origin Policy"],
    links: [
      { label: "Live Demo", href: "https://rendercore.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/rendercore" },
    ],
  },
  {
    id: "Systems - HTTP Client",
    name: "Requestman",
    badge: "In Progress",
    description:
      "A Postman-style API client built from raw TCP sockets upward on Node's net, tls, zlib and crypto alone: no http, no fetch, no dependencies. The completed 18-module engine track covers TLS, HTTP/1.1 framing, keep-alive, a timing waterfall, redirects, content encoding, a cookie jar, Basic/Bearer/Digest authentication, and an RFC 9111 cache with 304 revalidation. Every behavior is measured against curl and Node's fetch, and checked by deliberately breaking the code. A command-line tool and a React Studio follow in track two.",
    tags: ["Node.js", "HTTP/1.1", "TLS", "RFC 9110 / 9111", "React"],
    links: [
      { label: "Live Demo", href: "https://requestman.robertdoe.com" },
    ],
  },
  {
    id: "Systems - Reverse Engineering",
    name: "Disasm Forge",
    badge: "Complete",
    description:
      "A 21-module x86-64 NASM course built toward one destination: a working disassembler decoding REX, ModRM, and SIB bytes into Intel-syntax mnemonics by hand. The security thread runs from Module 2 onward and ends in a real stack overflow, with stack canaries, NX, and ASLR toggled individually in GDB to watch each mitigation change the outcome.",
    tags: ["x86-64", "NASM", "Reverse Engineering", "Exploit Mitigations"],
    links: [
      { label: "Live Demo", href: "https://disasm-forge.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/disasm-forge" },
    ],
  },
  {
    id: "Systems - HTML Parsing",
    name: "Tagsmith",
    badge: "Complete",
    description:
      "A spec-accurate HTML5 tokenizer implementing all 69 states of the WHATWG tokenization algorithm, written twice - once in JavaScript, once in Java - so correctness means passing in two type systems, not one. Built to root-cause why a sanitizer regex is never a substitute for a real tokenizer.",
    tags: ["HTML5 Spec", "Tokenizer", "JavaScript", "Java"],
    links: [
      { label: "Live Demo", href: "https://tagsmith.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/tagsmith" },
    ],
  },
  {
    id: "Systems - EdTech",
    name: "PyTech Hub",
    badge: "In Progress",
    description:
      "Data-structures-and-algorithms curriculum for Code Den, built in C, C++, and Python side by side so students feel a structure's real memory cost before trusting a library's version of it. Includes a React slide-deck composer for live sessions with running algorithm visualizations instead of hand-drawn diagrams.",
    tags: ["C", "C++", "Python", "EdTech", "Data Structures"],
    links: [
      { label: "Live Demo", href: "https://pytech-hub.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/pytech-hub" },
    ],
  },
  {
    id: "Systems - Research Tooling",
    name: "PRISMA Engine",
    badge: "Complete",
    description:
      "A runnable PRISMA-compliant systematic-literature-review pipeline - search formalization, deduplication, screening, data extraction, meta-analysis, and flow-diagram generation - built as 30 small, verifiable Python modules against free academic APIs. Built directly out of the literature-review methodology this PhD work depends on, rather than trusted from a library.",
    tags: ["Python", "PRISMA", "Literature Review", "Research Methods"],
    links: [
      { label: "Live Demo", href: "https://prisma-engine.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/prisma-engine" },
    ],
  },
  {
    id: "Systems - Machine Learning",
    name: "Tensorforge",
    badge: "Complete",
    description:
      "A 28-module Machine Learning and Deep Learning course implementing gradient descent, backpropagation, convolution, and attention from raw NumPy before graduating to scikit-learn and PyTorch. Direct groundwork for ML-driven XSS defense research: understanding what a classifier is actually doing before trusting it to gate real DOM mutations.",
    tags: ["Python", "NumPy", "PyTorch", "PhD Research"],
    links: [
      { label: "Live Demo", href: "https://tensorforge.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/tensorforge" },
    ],
  },
  {
    id: "Systems - AI Foundations",
    name: "Nyansapo AI",
    badge: "Complete",
    description:
      "AI foundations taught as tied-together layers, named for the Akan wisdom knot: AI, Machine Learning, Deep Learning, Generative AI, with working code and a shipped capstone at every layer, from a hand-coded neuron to a working RAG app. Companion piece to Tensorforge, built for the same reason: no black box between the researcher and the model.",
    tags: ["Python", "AI Foundations", "LLMs"],
    links: [
      { label: "Live Demo", href: "https://nyansapo-ai.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/nyansapo-ai" },
    ],
  },
  {
    id: "Systems - Browser APIs",
    name: "BOM Atlas",
    badge: "Complete",
    description:
      "A code-first tour of the Browser Object Model - window, navigator, history, storage, timers - verified against a real browser rather than reimplemented, since a hand-rolled stand-in for navigator would just be a plain object pretending to behave like the real one.",
    tags: ["JavaScript", "Browser APIs", "Reference"],
    links: [
      { label: "Live Demo", href: "https://bom-atlas.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/bom-atlas" },
    ],
  },
];

export const securityProjects = [
  {
    id: "Security - Binary Analysis",
    name: "LLVM Binary Instrumentation Toolkit",
    description:
      "Binary instrumentation tooling built on the LLVM toolchain to support security assessments of compiled executables, developed as part of memory-safety vulnerability research at Arizona State University. Used to analyze binaries for memory-safety weaknesses ahead of secure-compilation experiments.",
    tags: ["LLVM", "Binary Instrumentation", "Memory Safety", "C / C++", "Security Research"],
    links: [{ label: "GitHub", href: "https://github.com/Robert-Doe/" }],
  },
  {
    id: "Security - Protocol Security",
    name: "Protocol Security",
    description:
      "Email authentication and DNS security work spanning research and industry. On the research side, a measurement study - Email-Auth & DNSSEC Adoption Across African TLDs - quantifying SPF, DKIM, DMARC, and DNSSEC coverage and surfacing where the gaps are. On the industry side, DMARC-to-Reject: a safe-enforcement and BIMI rollout service that takes organizations from p=none to a fully enforced p=reject policy.",
    tags: ["DMARC", "SPF / DKIM", "DNSSEC", "BIMI", "Email Security", "Measurement Study"],
    links: [{ label: "GitHub", href: "https://github.com/Robert-Doe/" }],
  },
  {
    id: "Security - Browser Sandboxing",
    name: "Browser X-Ray",
    badge: "Complete",
    description:
      "A 35-module, two-track toy browser stack built from the OS process substrate up: address spaces, sandboxing primitives, and exploit mitigations first, then the applied browser engine and its policy layer (SOP, CORS, CSP, cookies) on top. Built so a claim like \"Site Isolation stops cross-origin memory reads\" is something personally implemented and attacked, not repeated from a writeup.",
    tags: ["Sandboxing", "Site Isolation", "Process Isolation", "Browser Security"],
    links: [
      { label: "Live Demo", href: "https://browser-xray.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/browser-xray" },
    ],
  },
  {
    id: "Security - XSS Research",
    name: "Breachlab",
    badge: "Complete",
    description:
      "A 19-module, attack-first Cross-Site Scripting curriculum organized around a five-mechanism taxonomy covering every documented XSS technique - tag parsing, event handlers, URI schemes, DOM sinks, context-escape/mXSS - each module making a real payload fire before studying what actually closes it. An earlier scratch draft of the same curriculum, Sparkbench, stays live as the historical first attempt at the format.",
    tags: ["XSS", "Vulnerability Research", "Flask", "Node.js", "AppSec Education"],
    links: [
      { label: "Live Demo", href: "https://breachlab.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/breachlab" },
    ],
  },
  {
    id: "Security - CSP & Trusted Types",
    name: "Trust Boundary",
    badge: "Complete",
    description:
      "A from-first-principles course in Content Security Policy and Trusted Types: a hand-written CSP header parser before ever trusting the browser's own, real enforcement against a live server, and a four-angle forgery campaign against Trusted Types proving the sink guard is an internal slot check, not an instanceof check.",
    tags: ["CSP", "Trusted Types", "DOM XSS", "Browser Security"],
    links: [
      { label: "Live Demo", href: "https://trust-boundary.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/trust-boundary" },
    ],
  },
  {
    id: "Security - HTML Parsing",
    name: "Foster Parser",
    badge: "Complete",
    description:
      "A hand-built HTML5 tree-construction engine implementing foster parenting, the WHATWG algorithm that relocates misnested table content to a position the source markup never specified, verified against a real browser at every step. Used as ground truth to explain a recurring root cause of mutation XSS: a sanitizer's own serialize-then-reparse cycle silently changing tree shape.",
    tags: ["HTML5 Parsing", "mXSS", "WHATWG Spec"],
    links: [
      { label: "Live Demo", href: "https://foster-parser.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/foster-parser" },
    ],
  },
  {
    id: "Security - Mutation XSS",
    name: "Mutagen",
    badge: "Complete",
    description:
      "An applied continuation of the tokenizer and tree-construction work above: 11 modules covering the full catalogue of mutation-XSS classes, a hardened sanitizer closing all of them, and a hard look at whether the platform's native Sanitizer API actually closes the gap - 115 assertions, all verified against a real browser.",
    tags: ["mXSS", "Sanitizer API", "DOMPurify", "Vulnerability Research"],
    links: [
      { label: "Live Demo", href: "https://mutagen.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/mutagen" },
    ],
  },
  {
    id: "Security - DOM Clobbering",
    name: "ClobberLab",
    badge: "Complete",
    description:
      "A 14-module, code-first course on DOM clobbering, the spec-mandated behavior that lets plain HTML with no script hijack JavaScript globals. It starts with a Node.js model of how a browser resolves a bare name, built from the named-property map and all five spec rules, each verified in a real browser. It then covers the attacks (element reordering via foster parenting, script-src hijacks, the eight vulnerable code patterns) and defenses measured rather than asserted, including why CSP is blind to most clobbering impact.",
    tags: ["DOM Clobbering", "Browser Security", "WHATWG Spec", "AppSec Education"],
    links: [
      { label: "Live Demo", href: "https://clobberlab.robertdoe.com" },
    ],
  },
  {
    id: "Security - Extension Security",
    name: "Manifesto",
    badge: "Complete",
    description:
      "A 25-module Manifest V3 Chrome extension course taught by building one real, cumulative extension end to end, including three shipped storage-migration modules, an OAuth2 flow, and forensic \"autopsies\" of real published extensions removed from the Chrome Web Store for malicious behavior.",
    tags: ["Chrome Extensions", "Manifest V3", "Extension Security"],
    links: [
      { label: "Live Demo", href: "https://manifesto.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/manifesto" },
    ],
  },
  {
    id: "Security - Network Security",
    name: "Packetlab",
    badge: "Complete",
    description:
      "A from-scratch networking curriculum run against a real home lab rather than a diagram: switching and routing, wireless handshakes, a home SOC built on Wireshark/Zeek/Suricata/ELK, vulnerability assessment, and a red-team/blue-team capstone against a network segmented by hand.",
    tags: ["Networking", "Home Lab", "SOC", "Vulnerability Assessment"],
    links: [
      { label: "Live Demo", href: "https://packetlab.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/packetlab" },
    ],
  },
  {
    id: "Security - Web Request Security",
    name: "Requestcraft",
    badge: "Complete",
    description:
      "GET and POST taken apart down to the raw socket bytes, then used to teach XSS and CSRF as the inevitable consequence of how those two methods actually work rather than as memorized vocabulary, with parallel PHP and Node implementations of every exploit and its fix.",
    tags: ["HTTP", "XSS", "CSRF", "PHP", "Node.js"],
    links: [
      { label: "Live Demo", href: "https://requestcraft.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/requestcraft" },
    ],
  },
  {
    id: "Security - DOM Reconciliation",
    name: "Reconcile Core",
    badge: "In Progress",
    description:
      "Research into where virtual-DOM diffing and HTML parsing meet mutation XSS: a 19-module attack curriculum, a from-scratch React-style Fiber reconciler (keyed diffing, double buffering, a real commit phase), and an ongoing research track checking every claim against React's actual source.",
    tags: ["Virtual DOM", "React Internals", "Reconciliation", "PhD Research"],
    links: [
      { label: "Live Demo", href: "https://reconcile-core.robertdoe.com" },
      { label: "GitHub", href: "https://github.com/Robert-Doe/reconcile-core" },
    ],
  },
];

export const certificates = pluralsightCertificates;

export const researchItems = [
  {
    year: "2024",
    title:
      "Harnessing Academic Integrity Among Students: Implementation of a Novel Web-Based Application for Plagiarism Detection and Prevention",
    venue:
      "Africa Education Review, Vol. 20(1-2), pp. 1-20 - Asamoah, P., Owusu-Bio, M. K., Doe, R., et al.",
    doi: "doi.org/10.1080/18146627.2024.2386941",
    badge: "Published",
    badgeClass: "badge-pub",
  },
  {
    year: "2025",
    title: "ML-Driven Approaches to XSS Defense",
    venue: "Research exploration",
    badge: "In Progress",
    badgeClass: "badge-wip",
  },
  {
    year: "2024",
    title: "Memory Safety Vulnerability Analysis via Binary Instrumentation and Secure Compilation Techniques",
    venue: "Research Assistant Work - Arizona State University",
    badge: "Archived",
    badgeClass: "badge-wip",
  },
  {
    year: "2024",
    title: "Blackbox and Deep Web Scanning: Methodologies for Automated Web Vulnerability Identification",
    venue: "Literature Review - Arizona State University",
    badge: "Archived",
    badgeClass: "badge-wip",
  },
];

export const contactLinks = [
  { prefix: "@", label: "Email", href: "mailto:robertdoe009@gmail.com" },
  { prefix: "<>", label: "GitHub", href: "https://github.com/Robert-Doe/" },
  { prefix: "in", label: "LinkedIn", href: "https://linkedin.com/in/robert-doe/" },
  { prefix: "www", label: "Blog", href: "https://mfantse.tech" },
];
